import store from '../redux/store';

export async function authFetch(url, options = {}) {
  const token = store.getState().app.token;
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const headers = {
    // Don't set Content-Type for FormData; the browser sets it with the boundary
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...options.headers,
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return fetch(url, { ...options, headers });
}
